<template lang="html">
  <v-flex v-model="dilogDownload" xs12 md12 v-if="snackbar && type_device !== 'desktop'" class="CSChatThai card-loading">
    <v-layout align-center justify-center row fill-height>
      <v-flex xs2 md2>
        <v-btn icon flat  @click="closedownload()"><v-icon style="font-size: 18px !important; color: #2463af;">close</v-icon></v-btn>
      </v-flex>
      <v-flex xs6 md6 style="font-weight: 700;">
        {{$t('Dialog.download.textDownload')}}
      </v-flex>
      <v-flex xs4 md4 style="justify-content: end; display: flex;">
        <!-- <v-btn style="color: white; border-radius: 26px;" color="#2463af" @click="downloadios()" v-if="deviceos === 'ios'" drak>ดาวน์โหลด</v-btn>
        <v-btn style="color: white; border-radius: 26px;" color="#2463af" @click="downloadios()" v-else-if="deviceos === 'unknown'" drak>ดาวน์โหลด</v-btn>
        <v-btn style="color: white; border-radius: 26px;" color="#2463af" @click="downloadandroid()" v-else drak>ดาวน์โหลด</v-btn> -->
        <v-btn style="color: white; border-radius: 26px; text-transform: none;" color="#2463af" @click="downloadapp()" drak>{{$t('AnswerQuestion.download')}}</v-btn>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
export default {
  props: {
    dilogDownload: Boolean
  },
  data () {
    return {
      deviceos: '',
      snackbar: '',
      textsnackbar: '',
      type_device: '',
      windowWidth: '',
    }
  },
  watch: {
    dialogDownload () {
      console.log(this.dialogDownload)
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    })
  },
  created () {
    // show download application
    const device = require('current-device').default
    this.deviceos = device.os
    this.snackbar = true
    // this.type_device = 'unknow'
    let isIpad = /Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1;
    if (device.os === 'unknown') {
      // isIpad = /Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1;
      // console.log(isIpad)
      if (isIpad) {
        this.type_device = 'tablet'
      } else {
        this.type_device = device.type
      }
    } else {
      this.type_device = device.type
    }
    // alert(`type: ${device.type}, os: ${device.os}, isipad: ${isIpad}`)
    console.log(isIpad)
    // console.log(navigator.userAgent)
    console.log(device)
    console.log(device.type)
    console.log(this.windowWidth)
  },
  methods: {
    downloadios () {
      // window.open('https://itunes.apple.com/th/app/onechat/id1394435274?mt=8').focus()
      window.open('https://qrcode.chat.one.th/api/v1/go-to-onechat').focus()
    },
    downloadandroid () {
      window.open('https://qrcode.chat.one.th/api/v1/go-to-onechat').focus()
      // window.open('https://play.google.com/store/apps/details?id=com.oneplatform.android.onechat').focus()
    },
    downloadapp () {
      window.open('http://onelink.to/2sjwf7').focus()
      // window.open('https://qrcode.chat.one.th/api/v1/go-to-onechat').focus()
    },
    closedownload () {
      this.snackbar = false
    },
  }
}
</script>

<style lang="css" scoped>
.card-loading {
  color: #2463af;
  background-color: rgb(255 255 255);
  margin: 0px;
  width: 100%;
  height: 10vh;
  bottom: 0px;
  position: fixed;
  padding: 5px !important;
  z-index: 1;
  border-top-right-radius: 10px;
  border-top-style: solid;
  border-top-left-radius: 10px;
  border-left-style: solid;
  border-right-style: solid;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/dialog/DownloadAppMobile.vue